require("./SummaryCauditList.less");

const React = require("react");

const QuestionType = require("~/types/Question.js").PropType;
const SummaryComment = require("../SummaryComment/SummaryComment.jsx");

const SummaryCauditList = React.createClass({
    propTypes: {
        Question: QuestionType.isRequired,
    },

    render() {
        const showCommentField = this.props.Question.AdditionalComment != "";
        const tableHeadings = this.props.Question.AnswerOptions.map(this.GetHeading);
        const numberOfColumns = this.props.Question.AnswerOptions.length;

        const score = this.props.Question.MaxScore === 0
            ?  ""
            : `${this.props.Question.Score}/${this.props.Question.MaxScore}`;

        return (<div className="cs-SummaryTable">
            <div className="cs-SummaryTable__Section1">
                <div className="cs-SummaryTable__Section1__Question"
                     dangerouslySetInnerHTML={{ __html: this.props.Question.DisplayHTML }}></div>
                <div className="cs-SummaryTable__Section1__Answer">See below</div>
                <div className="cs-SummaryTable__Section1__Points">
                    {score}
                </div>
            </div>
                <table className="table table-bordered cs-SummaryTable__Table">
                    <thead>
                        <tr>
                            {tableHeadings}
                        </tr>
                    </thead>
                        {this.GetRows()}
                </table>
            <div className="cs-SummaryTable__Comment">
                {showCommentField && (
                    <SummaryComment Comment={this.props.Question.AdditionalComment} />)}
            </div>
        </div>);
    },

    GetRows() {
        let rows = this.props.Question.AnswerSelections.map(this.GetRow);

        return rows;
    },

    GetRow(selection, i) {
        let cols = this.props.Question.AnswerOptions.map((option, j) => {
            const value = selection.SelectionText[j] || (<em>Not specified</em>);

            if (j === this.props.Question.AnswerOptions.length - 1) {
                return (<td key={i, j} className="cs-SummaryTable__data" colSpan={j}>
                    <div className="cs-SummaryTable__label">Discrepancies Noted</div>
                    <div className="cs-SummaryTable__data__text" >{value}</div>
                </td>);
            }
            else {
                return (<td key={i, j} className="cs-SummaryTable__data" >
                    <div className="cs-SummaryTable__data__text" >{value}</div>
                </td>);
            }
        });

        return (<tbody key={i }>
            <tr key="{i}1">
                {cols.slice(0, -1)}
            </tr>
            <tr key="{i}2">
                {cols[cols.length - 1]}
            </tr>
        </tbody>);
    },

    GetHeading(answerOption, i) {
        if (i === this.props.Question.AnswerOptions.length - 1) {
            return;
        }
        return (<th key={answerOption.GUID} className="cs-SummaryTable__header">
            {answerOption.DisplayText}
        </th>)
    }

});

module.exports = SummaryCauditList;


// WEBPACK FOOTER //
// ./src/components/SurveySummary/SummaryCauditList/SummaryCauditList.jsx